export enum RegisterStatus {
    Success = 0,
    Failed = 1,
    EmailExists = 2
}
